"use client";
import { CrossSellViewMode } from "@/api/AppApi/services/company/interfaces/ICompany";
import Separator from "@/app/components/lib/Separator";
import AssociatedProductsSkeleton from "@/app/components/pages-components/common/associated-products/AssociatedProductsSkeleton";
import CrossSellPanel from "./CrossSellPanel";
import { useCartCrossSell } from "./useCartCrossSell";
import { useCartCrossSellIds } from "./useCartCrossSellIds";

/** Inline cross-sell on the cart page — the default view mode. */
const CartCrossSellSection: React.FC = () => {
  const crossSell = useCartCrossSell(
    useCartCrossSellIds(),
    CrossSellViewMode.section,
  );

  if (!crossSell.enabled) return null;
  if (crossSell.isLoading) return <AssociatedProductsSkeleton />;
  // Never an empty section.
  if (!crossSell.hasProducts) return null;

  return (
    <section
      className="cart-crosssell-section"
      aria-label={crossSell.title || undefined}
    >
      {/* dir="auto" — merchant copy may be Arabic on an English storefront
          whenever only one locale is filled in upstream. */}
      <Separator
        startLabel={<span dir="auto">{crossSell.title}</span>}
        marginBottom={16}
      />
      <CrossSellPanel crossSell={crossSell} asGrid={crossSell.asGrid} />
    </section>
  );
};

export default CartCrossSellSection;
